// extracted by mini-css-extract-plugin
module.exports = {"textBox":"TextBox_textBox__2rxhR","large":"TextBox_large__1Ep93"};